import React from 'react';

import styles from './starRatingStyles';

import Star from 'buyside/components/presentation/Star/star';

const StarRating = ({ id, rating, ratingCount = null, className = '', size = 'small' }) => {
  // Ratings are saved on a score of 1-10,
  // but we display them on a scale of 1-5
  const displayedRating = rating / 2;

  const setFillPercentage = index => {
    // This takes the five stars in the rating and fills them one-by-one
    // to create the final star rating.
    //
    // To see if each star should be completely filled, we check its
    // index [1-5] against the total rating. If the rating is higher
    // than the index, the star is filled. If not, it's either unfilled
    // or half-filled.

    if (displayedRating >= index + 1) {
      // filled
      return 100;
    } else if (displayedRating > index) {
      // half-filled
      return (displayedRating - index) * 100;
    } else {
      // empty
      return 0;
    }
  };
  return (
    <div className={className}>
      {[0, 1, 2, 3, 4].map(index => {
        return (
          <Star
            key={index}
            id={`star-${id}-${index}`}
            fillPercentage={setFillPercentage(index)}
            size={size}
          />
        );
      })}
      {ratingCount && ratingCount > 3 && (
        <div className={styles.votes}>
          {ratingCount} vote{ratingCount > 1 ? 's' : ''}
        </div>
      )}
      {ratingCount && ratingCount < 4 && (
        <div className={styles.votes}>
          {4 - ratingCount} vote{4 - ratingCount === 1 ? '' : 's'} needed
        </div>
      )}
    </div>
  );
};

export default StarRating;
